import type { ReactNode } from 'react';
import { Tooltip } from './Tooltip';

interface CardProps {
  title?: string;
  subtitle?: string;
  tooltip?: string;
  children: ReactNode;
  className?: string;
  /** Renders a colored left border accent: 'blue' | 'indigo' | 'green' | 'orange' */
  accent?: 'blue' | 'indigo' | 'green' | 'orange' | 'none';
}

const accentClasses = {
  blue: 'border-l-4 border-l-blue-500',
  indigo: 'border-l-4 border-l-indigo-500',
  green: 'border-l-4 border-l-green-500',
  orange: 'border-l-4 border-l-orange-500',
  none: '',
};

export function Card({ title, subtitle, tooltip, children, className = '', accent = 'none' }: CardProps) {
  return (
    <div
      className={[
        'bg-white rounded-xl shadow-sm border border-gray-200',
        accentClasses[accent],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {(title || subtitle) && (
        <div className="px-5 pt-5 pb-3">
          {title && (
            <div className="flex items-center gap-1">
              <h2 className="text-sm font-semibold text-gray-800 tracking-wide uppercase">{title}</h2>
              {tooltip && <Tooltip text={tooltip} />}
            </div>
          )}
          {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
      )}
      <div className={title || subtitle ? 'px-5 pb-5' : 'p-5'}>{children}</div>
    </div>
  );
}
